module.exports = __webpack_public_path__ + "media/images/partners/safer-internet-6b686113f87be13c258d11b2c7650106.svg";